import { Navigate, useLocation } from 'react-router-dom'
import { useAdmin } from '../../hooks/useAdmin'

const AdminProtectedRoute = ({ children }) => {
  const { isAdmin, loading } = useAdmin()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-accent-500"></div>
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return children
}

export default AdminProtectedRoute
